import React, { Component } from "react";
import PropTypes from "prop-types";

import GenericChartComponent from "../../GenericChartComponent";
import { getAxisCanvas } from "../../GenericComponent";

class BaselineSeparator extends Component {
  constructor(props) {
    super(props);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
  }

  drawOnCanvas(ctx, moreProps) {
    const { separatorPrice } = this.props;

    if (separatorPrice == null) {
      return;
    }

    const { chartConfig } = moreProps;

    if (!chartConfig || !chartConfig.yScale || !chartConfig.width) {
      return;
    }

    const { yScale, width } = chartConfig;
    const separatorY = yScale(separatorPrice);

    // Professional styling - subtle and clean
    const strokeColor = "#8E9AAF"; // Muted blue-gray
    const strokeWidth = 1; // Thin line

    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = strokeWidth;
    ctx.globalAlpha = 0.8; // Slightly transparent

    // Dashed line for subtlety
    ctx.setLineDash([8, 4]); // 8px dash, 4px gap

    ctx.beginPath();
    ctx.moveTo(0, separatorY);
    ctx.lineTo(width, separatorY);
    ctx.stroke();

    // Reset line dash for other drawings
    ctx.setLineDash([]);
    ctx.globalAlpha = 1.0;
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        canvasToDraw={getAxisCanvas}
        canvasDraw={this.drawOnCanvas}
        drawOn={["mousemove", "pan", "drag"]}
      />
    );
  }
}

BaselineSeparator.propTypes = {
  separatorPrice: PropTypes.number,
  stroke: PropTypes.shape({
    color: PropTypes.string,
    opacity: PropTypes.number,
    width: PropTypes.number,
    dash: PropTypes.string,
  }),
  hovering: PropTypes.bool,
  className: PropTypes.string,
};

BaselineSeparator.defaultProps = {
  stroke: {
    color: "#607D8B",
    opacity: 0.8,
    width: 1,
    dash: "ShortDash",
  },
  hovering: false,
  className: "react-stockcharts-baseline-separator",
};

export default BaselineSeparator;
